import React from 'react';

import { Modal, Box, Grid, Typography, Button } from '@mui/material';
import { ReactComponent as CheckOk } from '../../../assets/images/svg/shops/request/check_ok.svg';
import useStyles from '../../../assets/styles/pages/ShopRequest';

interface Props {
  open: boolean;
  onClose: () => void;
  flgPix: number;
  idRequest: string;
  idRestaurante: string;
  handleToPage: (path: string) => void;
}

const styleModalBottom = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

export const SuccessRequestModal = ({
  open,
  onClose,
  flgPix,
  idRequest,
  idRestaurante,
  handleToPage,
}: Props): JSX.Element => {
  const styles = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModalBottom}>
        <Grid container item xs={12} justifyContent="center">
          <CheckOk className={styles.iconModal} />
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Typography
            variant="h6"
            component="h2"
            className={styles.titleModal}
            style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
          >
            Informação
          </Typography>
          <Typography sx={{ mt: 2 }} className={styles.textModal}>
            Pedido enviado com sucesso!
          </Typography>
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Button
            className={styles.btnSubmit}
            style={{ width: '80%' }}
            onClick={() =>
              handleToPage(
                flgPix === 1
                  ? `/dashboard/user/request/detail/upload/file/pix/${window.btoa(
                      idRequest,
                    )}/${idRestaurante}/true`
                  : '/dashboard/user/request',
              )
            }
            variant="contained"
          >
            Ok
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};
